import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { id: "nav_right_group" }
const _hoisted_3 = {
  "aria-label": "navigation",
  id: "nav"
}
const _hoisted_4 = { id: "slogan" }
const _hoisted_5 = { class: "slogan list ul" }
const _hoisted_6 = { class: "slogan list li" }
const _hoisted_7 = { class: "slogan list li" }
const _hoisted_8 = { class: "slogan list li" }
const _hoisted_9 = { class: "lang select ul" }
const _hoisted_10 = { class: "lang select li" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("g", { "stroke-width": ".3" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0 0h16v12H0z",
    fill: "#fff",
    "data-name": "Path 559"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0 4.3h16v3.3H0z",
    fill: "#003580",
    "data-name": "Path 560"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.4 0h3.3v12H4.4z",
    fill: "#003580",
    "data-name": "Path 561"
  })
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "lang select li" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<g stroke-width=\".3\"><path d=\"M0 0h16v12H0z\" fill=\"#012169\" data-name=\"Path 562\"></path><path d=\"m1.9 0 6 4.5L14.2 0H16v1.5L10 6l6 4.5V12h-2L8 7.5 2 12H0v-1.5l6-4.4-6-4.5V0z\" fill=\"#fff\" data-name=\"Path 563\"></path><path d=\"m10.6 7 5.4 4v1L9.2 7zM6 7.5l.2.9L1.3 12H0zM16 0 9.7 4.9l.1-1.1 5-3.7zM0 0l6 4.4H4.5L0 1.1z\" fill=\"#c8102e\" data-name=\"Path 564\"></path><path d=\"M6 0v12h4V0zM0 4v4h16V4z\" fill=\"#fff\" data-name=\"Path 565\"></path><path d=\"M0 4.8v2.4h16V4.8zM6.8 0v12h2.4V0z\" fill=\"#c8102e\" data-name=\"Path 566\"></path></g>", 1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("article", null, [
    _createElementVNode("section", null, [
      _createElementVNode("header", null, [
        _createVNode(_component_router_link, {
          "aria-label": "navigate to home page",
          id: "navSignup",
          to: "/home"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              "aria-label": "invested logo",
              class: "invested",
              src: _ctx.logo
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("nav", _hoisted_3, [
            _createVNode(_component_router_link, {
              "aria-label": "navigate to about page",
              id: "navSignup",
              to: "/about",
              class: _normalizeClass({ selected: _ctx.$route.path === '/about' })
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("about-header")), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, _toDisplayString(_ctx.t("first-header-1")), 1),
              _createElementVNode("li", _hoisted_7, _toDisplayString(_ctx.t("first-header-2")), 1),
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.t("first-header-3")), 1)
            ]),
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", _hoisted_10, [
                (_openBlock(), _createElementBlock("svg", {
                  class: _normalizeClass(["lang select flag", {
                    selected: _ctx.locale === 'fi',
                    unselected: _ctx.locale === 'en',
                  }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLocale('fi'))),
                  width: "16",
                  height: "12",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _hoisted_12, 2))
              ]),
              _createElementVNode("li", _hoisted_13, [
                (_openBlock(), _createElementBlock("svg", {
                  class: _normalizeClass(["lang select flag", {
                    selected: _ctx.locale === 'en',
                    unselected: _ctx.locale === 'fi',
                  }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLocale('en'))),
                  width: "16",
                  height: "12",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _hoisted_15, 2))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_16, [
      _createVNode(_component_router_view),
      _createElementVNode("footer", null, [
        _createVNode(_component_FooterComponent)
      ])
    ])
  ]))
}